import { ReactComponent } from '../../../styles/icons/location.svg'
import { WrapSvgIcon } from './helpers'

const LocationIcon = WrapSvgIcon(ReactComponent)

export default LocationIcon
